import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import "./Constac.css";
import Images from "../../Assets/Images/Index";
function Contact() {
  return (
    <div>
      <Header />
      <div className="contact-container">
        <div className="contact-main container">
          <h1>Contact Us</h1>
          <p>Any questions or remarks? Just write us a message!</p>
        </div>
        <div className=" contactus-cont container ">
          <div className="form-container col-lg-10">
            <div className="input-row">
              <div className="input-group-contact ">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  required
                />
              </div>
              <div className="input-group-contact ">
                <label>Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Enter your name"
                  required
                />
              </div>
            </div>

            <div className="input-group-contact ">
              <textarea required></textarea>
            </div>
          </div>

          <div className="col-lg-2  btn-tele ">
            <button type="submit" className="btn-container submit-btn">
              <img src={Images.vector} alt="Send" />
              Send
            </button>
          </div>
        </div>
        <div className="info-section d-flex justify-content-center ">
          <div className="info-card-left">
            <div className="contact-icon-container">
              <img src={Images.qr} alt="qr" />
            </div>
            <div className="mt-5">
              <h2 className="info-title">ABOUT Q-FLYERS</h2>
              <p className="info-text">
                A Digital Menu Card SaaS is a cloud-based platform that allows
                restaurants.
              </p>
            </div>
          </div>
          <div className="info-card">
            <div className="contact-icon-container">
              <img src={Images.phone} alt="phone" />
            </div>
            <div className="mt-5">
              <h2 className="info-title">PHONE (LANDLINE)</h2>
              <p className="info-text">+91-4223563362</p>
              <p className="info-text">+91-4223563362</p>
            </div>
          </div>
          <div className="info-card-right">
            <div className="contact-icon-container">
              <img src={Images.location} alt="location" />
            </div>
            <div className="mt-5">
              <h2 className="info-title">OUR LOCATION</h2>
              <p className="info-text">
                Find our services available at multiple locations across the
                region.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;
